import { render, staticRenderFns } from "./vacunasShow.vue?vue&type=template&id=ea7ce996"
import script from "./vacunasShow.vue?vue&type=script&lang=js"
export * from "./vacunasShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports